import React, { Component } from 'react';
import moment from 'moment';
import Validator from 'validatorjs';
import { Row, Col, Modal, Button, Form } from 'react-bootstrap';

import { Http } from '../../../../support';
import { FormControl } from '../../../../facturotopia';
import LoadingButton from '../../../../facturotopia/LoadingButton';
import ResponseError from '../../../../shared/responses/ResponseError';
import ResponseResult from '../../../../shared/responses/ResponseResult';

class ConfirmBuyPackageTransfer extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      data: {},
      isValid: false,
      validator: new Validator({}, this.rules({})),
    };
  }

  rules(data) {
    return {
      'fecha': ['required'],
      'banco': ['required', 'string'],
      'numero_autorizacion': ['required', 'string'],
    }
  }

  validate(data) {
    const validator = new Validator(data, this.rules(data));

    validator.check();

    this.setState({
      validator
    });

    return validator;
  }

  handleOnClose = () => {
    this.props.history.replace('/cuenta/historial-compra')
  }

  handleOnChange = (value) => {
    const data = {
      ...this.state.data,
      ...value
    }

    const validator = this.validate(data);

    this.setState({
      data,
      isValid: validator.passes(),
    });
  }

  handleOnPaymentWithTransfer = async () => {
    const { id } = this.props.match.params;

    this.setState({
      busy: true,
    });

    const fecha = moment(this.state.data.fecha).format('YYYY-MM-DD HH:mm') + ':00';

    const data = {
      ...this.state.data,
      fecha: fecha
    }

    const params = {
      ...data
    };

    try {
      const response = await Http.patch(`api/compras/${id}/confirmar-transferencia`, params);

      this.setState({
        showResult: true,
        result: response
      });

    } catch (response) {
      this.setState({
        showError: true,
        error: response.data || response
      });
    } finally {
      this.setState({
        busy: false
      });
    }
  }

  renderResult = () => {
    const { result } = this.state

    return (
      <div className="result-container">
        <ResponseResult
          title="Completado"
          result={ result }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  renderError = () => {
    const { error } = this.state

    return (
      <div className="result-container">
        <ResponseError
          title="Error"
          error={ error }
          onAction={ this.handleOnAction }
        />
      </div>
    );
  }

  handleOnAction = (action) => {
    if (action === 'reset') {
      this.props.history.replace('/cuenta/historial-compra');
    }

    if (action === 'success') {
      const { id } = this.props.match.params;

      this.props.history.push(`/cuenta/historial-compra/${id}/info`);
    }
  }

  render() {
    const rules = this.rules();
    const { data, showResult, showError, isValid, busy } = this.state;

    if (!!showResult) {
      return this.renderResult();
    }

    if (!!showError) {
      return this.renderError();
    }

    return (
      <Modal backdrop="static" keyboard={ false } show={ true } centered={ true } onHide={ this.handleOnClose }>
        <Modal.Header closeButton>
          <Modal.Title>
            Pago con transferencia
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form autoComplete="off">
            <Row>
              <Col>
                <FormControl type="datetime-picker"
                  label="Fecha de operación"
                  name="fecha"
                  value={ data.fecha }
                  rules={ rules.fecha }
                  onChange={ this.handleOnChange }
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <FormControl type="text"
                  label="Banco"
                  name="banco"
                  value={ data.banco }
                  rules={ rules.banco }
                  onChange={ this.handleOnChange }
                />
              </Col>

              <Col>
                <FormControl type="text"
                  label="Número de autorización"
                  name="numero_autorizacion"
                  value={ data.numero_autorizacion }
                  rules={ rules.numero_autorizacion }
                  onChange={ this.handleOnChange }
                />
              </Col>
            </Row>

            <Row className="mt-3">
              <Col>
                <Button type="button"
                  variant="secondary"
                  onClick={ this.handleOnClose }
                >
                  Cancelar
                </Button>
              </Col>

              <Col className="text-right">
                <LoadingButton type="button"
                  variant="primary"
                  disabled={ !isValid }
                  loading={ busy || false }
                  onClick={ this.handleOnPaymentWithTransfer }
                >
                  { !!busy ? 'Procesando...' : 'Continuar'}
                </LoadingButton>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
    )
  }
}

export default ConfirmBuyPackageTransfer;
